<template>
  <apexchart width="1000" height="500" :options="chartOptions" :series="series" />
</template>

<script>
export default {
  data() {
    return {
      series: [
        {
          name: 'Пшеница 4 класс',
          data: [2222, 42663, 24167]
        },
        {
          name: 'Пшеница 5 класс',
          data: [25000, 21000, null]
        },
        {
          name: 'Ячмень',
          data: [8000, null, null]
        },
        {
          name: 'Пшеница 3 класс',
          data: [null, 7000, null]
        },
        {
          name: 'Кукуруза',
          data: [null, null, null]
        }
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: {
            show: true
          }
        },
        title: {
          text: 'График 8 (Грузооборот по культурам)'
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: []
        },
        labels: ['Агрикалчер Кубань', 'Зерно-трейд', 'Агрикалчер Ростов'],
        xaxis: {
          type: 'category'
        },
        yaxis: [{
          title: {
            text: 'Грузооборот, т',
          }
        }],
        legend: {
          horizontalAlign: 'left',
          offsetX: 40
        },
        stroke: {
          width: [2, 1, 1, 1]
        },
        // TODO: доработать, чтобы не писались значения для первой колонны
      },
    };
  }
};
</script>

<style scoped>

</style>